module.exports = __webpack_public_path__ + "img/function.7ad9b613.svg";